import Work1 from "../../assets/work1.png";
import Work2 from "../../assets/work2.png";
import Work3 from "../../assets/work3.png";
import Work4 from "../../assets/work4.png";
import Work5 from "../../assets/work5.png";

export const projectsData = [
  {
    id: 1,
    image: Work3,
    title: "Landing Page",
    category: "web",
    link: "https://initialgr.github.io/ptbam/",
  },
  {
    id: 2,
    image: Work2,
    title: "Landing Page",
    category: "web",
    link: "https://initialgr.github.io/ptbam/",
  },
  {
    id: 3,
    image: Work1,
    title: "Landing Page",
    category: "design",
    link: Work1,
  },
  {
    id: 4,
    image: Work4,
    title: "Login Page",
    category: "design",
    link: Work4,
  },
  {
    id: 5,
    image: Work5,
    title: "Flutter Slicing",
    category: "app",
    link: Work5,
  },
];

export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "Web",
  },
  {
    name: "app",
  },
  {
    name: "design",
  },
];
